import moment from 'moment';

const fromISOtoFormat = (fromDate, dateFormat = 'DD MMMM YYYY - HH:mm') => moment(fromDate).format(dateFormat);

const reportStartDate = (date) => date.startOf('day').unix();
const reportEndDate = (date) => date.endOf('day').unix();

// eslint-disable-next-line import/prefer-default-export
export { fromISOtoFormat, reportEndDate, reportStartDate };
